module.exports = __webpack_public_path__ + "img/logo-bayton-tech-white.1ebabe30.svg";